// Returns true the first time it is called for `key` on the current local
// calendar day, and false for the rest of that day. The last-used date is
// persisted in localStorage, so it survives reloads and the back-to-home hard
// reload (unlike a useRef, which resets on every mount). Calling it marks today
// as used, so treat a `true` result as "go ahead and do the once-a-day thing".
//
// Fails open: if localStorage is unavailable (private mode, quota, etc.) it
// returns true so the gated action still runs rather than being silently
// suppressed forever.
export function firstTimeToday(key: string): boolean {
  const today = localDateString();
  try {
    if (localStorage.getItem(key) === today) {
      return false;
    }
    localStorage.setItem(key, today);
    return true;
  } catch {
    return true;
  }
}

function localDateString(date = new Date()): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
